define((require) => {
    "use strict";

    var Action        = require("shared/ui/experience/action/Action"),
        ActionFactory = require("shared/ui/experience/action/ActionFactory"),
        Backbone      = require("backbone"),
        ImprovedModel = require("shared/zbone/ImprovedModel"),
        Permissions   = require("shared/security/Permissions"),
        RestApi       = require("shared/services/RestApi"),
        Syncer        = require("shared/services/sync/Syncer");

    /**
     * A PrototypeAction acts as a template for actions to be created based on it when it's
     * embedded in experiences. The created actions keep a reference to the prototype in the
     * actionId property.
     *
     * A PrototypeActions has a reference to the PrototypeWidget that it belongs to.
     */
    return ImprovedModel.extend("PrototypeAction", {

        defaults: {
            action: null,
            companyId: null
        },

        relations: [{
            key: "action",
            relatedModel: Action,
            type: Backbone.One,
            // See http://dhruvaray.github.io/backbone-associations/specify-associations.html#sa-map
            map: function(value) {
                // Only map for raw object representations
                return value instanceof Action ? value : ActionFactory.newActionFromType(value.type, value);
            }
        }],

        constructor: function() {
            this.__super();

            Syncer.State.init(this, {
                permissions: {
                    destroy: Permissions.Privileges.ADMIN,
                    save:    Permissions.Privileges.ADMIN
                }
            });
        },

        computed: {
            actionIsInUse: {
                deps: ["action"],
                value: function(action) {
                    return action && action.get("usedBy").length > 0;
                }
            }
        },

        /**
         * Returns the REST API URL for a PrototypeAction. Used internally by the synchronization
         * mechanism.
         *
         * @returns {String} REST API URL
         */
        url: function() {
            var id = this.get("id");

            if (id) {
                // URL for GET, PUT and DELETE, i.e. "api/actions/{actionId}"
                return RestApi.pathToSpecificResource(RestApi.Collections.ACTIONS, id);
            }

            // URL for POST, i.e. "api/actions"
            return RestApi.pathToCollection(RestApi.Collections.ACTIONS);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/PrototypeAction.js